import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function GripIcon({
  size = MAIN_THEME.iconSize.large,
  color = MAIN_THEME.colors.brandGray30,
}: ISvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.25 0H16.65C17.3953 0 18 0.587344 18 1.3125V6.5625C18 7.28711 17.3953 7.875 16.65 7.875H11.25C10.5041 7.875 9.9 7.28711 9.9 6.5625V1.3125C9.9 0.587344 10.5041 0 11.25 0ZM12.6 5.25H15.3V2.625H12.6V5.25ZM1.35 0H6.75C7.49531 0 8.1 0.587344 8.1 1.3125V6.5625C8.1 7.28711 7.49531 7.875 6.75 7.875H1.35C0.604126 7.875 0 7.28711 0 6.5625V1.3125C0 0.587344 0.604126 0 1.35 0ZM2.7 5.25H5.4V2.625H2.7V5.25ZM11.25 20.125H16.65C17.3953 20.125 18 20.7123 18 21.4375V26.6875C18 27.4121 17.3953 28 16.65 28H11.25C10.5041 28 9.9 27.4121 9.9 26.6875V21.4375C9.9 20.7123 10.5041 20.125 11.25 20.125ZM12.6 25.375H15.3V22.75H12.6V25.375ZM1.35 20.125H6.75C7.49531 20.125 8.1 20.7123 8.1 21.4375V26.6875C8.1 27.4121 7.49531 28 6.75 28H1.35C0.604126 28 0 27.4121 0 26.6875V21.4375C0 20.7123 0.604126 20.125 1.35 20.125ZM2.7 25.375H5.4V22.75H2.7V25.375ZM11.25 10.0625H16.65C17.3953 10.0625 18 10.6498 18 11.375V16.625C18 17.3496 17.3953 17.9375 16.65 17.9375H11.25C10.5041 17.9375 9.9 17.3496 9.9 16.625V11.375C9.9 10.6498 10.5041 10.0625 11.25 10.0625ZM12.6 15.3125H15.3V12.6875H12.6V15.3125ZM1.35 10.0625H6.75C7.49531 10.0625 8.1 10.6498 8.1 11.375V16.625C8.1 17.3496 7.49531 17.9375 6.75 17.9375H1.35C0.604126 17.9375 0 17.3496 0 16.625V11.375C0 10.6498 0.604126 10.0625 1.35 10.0625ZM2.7 15.3125H5.4V12.6875H2.7V15.3125Z"
        fill={color}
      />
    </svg>
  );
}
